import { DashboardContext } from "contexts/DashboardContext";
import { useState, useContext } from "react";
import { DateObject } from "react-multi-date-picker";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

import { CalendarViewSetting } from "./CalendarViewSetting";
import { ScheduleItemData } from "./interfaces";

interface Props {}

export type SavedSchedule = {
  id?: string;
  name: string;
  schedule: ScheduleItemData[];
  isRecurring?: boolean;
  recurring?: "Specific days" | "Weekly" | "Fortnightly";
  specificDates?: DateObject | DateObject[] | null;
  startDate?: DateObject | DateObject[] | null;
  endDate?: DateObject | DateObject[] | null;
};

interface OrganisationData {
  loadKey: number;
}

interface ConfirmModalProps {
  message: string;
  data: any;
  onConfirm: (data: any) => void;
}

export const OrganiseScheduleSetting: WidgetSettingFC<OrganisationData, Props> = ({
  data,
  setData,
  settings: { schedule },
}) => {
  const {
    data: { savedActivities, savedSchedules, assignedSchedules },
    setData: setGlobalData,
  } = useContext(DashboardContext);

  const assignNewSchedules = (
    schedules: { [date: string]: SavedSchedule },
    newSavedSchedules: SavedSchedule[],
  ) => {
    setGlobalData({
      assignedSchedules: schedules,
      savedSchedules: newSavedSchedules,
    });
  };

  const saveNewActivities = (newActivities: ScheduleItemData[]) => {
    setGlobalData({ savedActivities: newActivities });
  };

  return (
    <OuterContainer>
      <p>Organise Schedules</p>
      <CalendarViewSetting
        savedActivities={savedActivities || []}
        savedSchedules={savedSchedules || []}
        onSubmit={assignNewSchedules}
        saveNewActivities={saveNewActivities}
        assignedSchedules={assignedSchedules || {}}
      />
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
  width: 100%;
  margin-bottom: 35px;
`;
